export const formatApiErrorDetail = (value: unknown, fallback = 'Request failed'): string => {
  if (typeof value === 'string') {
    return value.trim() || fallback
  }
  if (value && typeof value === 'object') {
    const payload = value as Record<string, unknown>
    for (const key of ['blockingReason', 'message', 'error', 'detail']) {
      const item = payload[key]
      if (typeof item === 'string' && item.trim()) {
        return item.trim()
      }
    }
    try {
      return JSON.stringify(value)
    } catch {
      return fallback
    }
  }
  return fallback
}

export const formatAxiosErrorDetail = (error: unknown, fallback = 'Request failed'): string => {
  const anyError = error as any
  const responseDetail = anyError?.response?.data?.detail
  if (responseDetail !== undefined) {
    return formatApiErrorDetail(responseDetail, fallback)
  }
  const responseData = anyError?.response?.data
  if (responseData !== undefined) {
    return formatApiErrorDetail(responseData, fallback)
  }
  return formatApiErrorDetail(anyError?.message, fallback)
}
